
























































import { Component, Vue } from 'vue-property-decorator';
import Strings from '@/resources/default_data/strings';
import Http from '@/Http';

interface Version {
    description: string
    created_at: string
    version: string
    short_description: string
}

@Component
export default class AndroidBlock extends Vue {
  public st:object = Strings.default();
  public showDialog:boolean = false;
  public versions: Array<Version> = [];
  public tab = 0;

  created () {
    this.getInfo();
  }

  public getInfo () {
    (new Http()).request({ url: 'android/versions' })
      .then((res:any) => {
        this.versions = res.data.data;
      });
  }
}
